import routes from '@routes/config';

export default [{
    path: routes.note.index,
    name: routes.note.index,
    component: () => import(/* webpackChunkName: "Note" */  '@components/Note/Index')
}]
